import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  CircularProgress,
  Chip,
  Checkbox,
  Button,
  IconButton,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from "@mui/material";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import UpdateBatchDialog from "./UpdateBatchDialog";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
import { GridDeleteIcon } from "@mui/x-data-grid";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Swal from "sweetalert2";
import { toast } from "react-hot-toast";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import MobileView from "../../Components/views/MobileView";
import DesktopView from "../../Components/views/DesktopView";
import { jsPDF } from "jspdf";
import { pink } from "@mui/material/colors";

import CheckAndReturn from "../../utility/CheckAndReturn";
const BatchEnrollment = () => {
  const { company_id, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const [showAlreadyDialog, setShowAlreadyDialog] = useState(false);
  const [alreadyInList, setAlreadyInList] = useState([]);
  const canUpdate = CheckAndReturn.PermissionHandler(
    "update-Enrollment",
    permissions
  );

  const canDelete = CheckAndReturn.PermissionHandler(
    "delete-enrolled-student",
    permissions
  );
  const canMove = CheckAndReturn.PermissionHandler(
    "move-enrolled-student",
    permissions
  );

  const rowsPerPageOptions = [20, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  const [selectedBatch, setSelectedBatch] = useState("All");
  const [batchFilter, setBatchFilter] = useState("Unassigned");
  const [searchType, setSearchType] = useState("full_name");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [students, setStudents] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [batches, setBatches] = useState([]);

  // ✅ Open / Close Dialog
  const handleUpdate = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSort = (field) => {
    if (field === "action" || field === "batch_name" || field === "status")
      return; // ignore action column
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // ✅ Fetch Students API
  const fetchStudents = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        company_id,
        type: batchFilter, // "All" | "Assigned" | "Unassigned"
        page: page + 1, // Laravel pagination starts at 1
        per_page: rowsPerPage,
        search: searchTerm,
        search_by: searchType,
        selectedBatch: selectedBatch,
        sort_field: sortField, // 👈 add this
        sort_order: sortOrder, // 👈 add this
      };

      const result = await configServ.allStudents(dataToSend);

      if (result?.status === true) {
        setStudents(result.data);
        setTotal(result.pagination?.total || 0);
      } else {
        setStudents([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Auto Fetch When Filters Change
  useEffect(() => {
    fetchStudents();
    setSelectedRows([]);
  }, [
    batchFilter,
    searchTerm,
    searchType,
    rowsPerPage,
    page,
    selectedBatch,
    sortField,
    sortOrder,
  ]);

  // get active batches
  const fetchbatches = async () => {
    try {
      // setLoading(true);
      const dataToSend = {
        company_id,
      };

      const result = await configServ.getActiveBatches(dataToSend);

      if (result?.status === true) {
        setBatches(result.data);
      } else {
        setBatches([]);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setBatches([]);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchbatches();
  }, []);

  // ✅ Handlers
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleBatchChange = (e) => setSelectedBatch(e.target.value);
  const handleFilterChange = (e) => setBatchFilter(e.target.value);
  const handleSearchTypeChange = (e) => setSearchType(e.target.value);
  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  // ✅ Select All / Individual Rows
  const handleSelectAll = () => {
    if (selectedRows.length === students.length) {
      setSelectedRows([]);
    } else {
      const allRowIds = students.map((row) => ({
        id: row.id,
        student_id: row.id,
        student_roll:
          row.student_roll !== undefined &&
          row.student_roll !== null &&
          row.student_roll !== ""
            ? row.student_roll
            : row.roll_no ?? "", // ✅ Fallback to roll_no if student_roll is empty
      }));
      setSelectedRows(allRowIds);
    }
  };

  const handleRowCheckboxChange = (row) => {
    const selectedRowId = row.id;
    const selectedStudentId = row.id;

    if (
      selectedRows.some(
        (item) =>
          item.id === selectedRowId && item.student_id === selectedStudentId
      )
    ) {
      setSelectedRows((prev) =>
        prev.filter(
          (item) =>
            !(
              item.id === selectedRowId && item.student_id === selectedStudentId
            )
        )
      );
    } else {
      setSelectedRows((prev) => [
        ...prev,
        {
          id: selectedRowId,
          student_id: selectedStudentId,
          student_roll:
            row.student_roll !== undefined &&
            row.student_roll !== null &&
            row.student_roll !== ""
              ? row.student_roll
              : row.roll_no ?? "", // ✅ Same fallback
        },
      ]);
    }
  };

  const handleSaveBatch = async (selectedBatch) => {
    // console.log("selectedBatch", selectedBatch);

    if (!selectedBatch || selectedRows.length === 0) {
      toast.error("Please select a batch and at least one student!");
      return;
    }

    // 🧩 Prepare payload for both cases (assign or move)
    const payload = {
      company_id: company_id, // from Redux state
      students: selectedRows, // [{id:1, student_id:1}, ...]
    };

    let apiCall = null;
    let successMsg = "";

    if (selectedBatch.isMove) {
      // 🟡 Move student logic
      payload.old_batch_id = selectedBatch.from;
      payload.new_batch_id = selectedBatch.to;

      apiCall = configServ.bulkAssignment(payload);
      successMsg = "Students moved successfully!";
    } else {
      // 🔵 Assign student logic
      payload.batch_id = selectedBatch.batchId;

      apiCall = configServ.assignStudentsToBatch(payload);
      successMsg = "Students assigned successfully!";
    }

    try {
      setLoading(true);

      const response = await apiCall;

      if (response.status) {
        toast.success(response.message || successMsg);

        // 🟡 If some students were already in the target batch
        if (response.already_in_new_batch?.length > 0) {
          setAlreadyInList(response.already_in_new_batch);
          setShowAlreadyDialog(true);
        }

        // ✅ Refresh data and reset state
        fetchStudents();
        setSelectedRows([]);
        setSelectedBatch("All");
        setOpenDialog(false);
      } else {
        toast.error(response.data?.message || "Failed to process request.");
      }
    } catch (error) {
      console.error("Batch operation error:", error);
      toast.error("Something went wrong while processing the batch.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Styles
  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#010911ff",
    color: "white",
    padding: 8,
    textAlign: "center",
  };
  const cellStyle = { py: 0.5, textAlign: "center" };
  const rowStyle = {
    "&:hover": { background: "#f5faff" },
  };

  // const headers = [
  //   "Registration No",
  //   "Student Name",
  //   "Father Name",
  //   ...(selectedBatch === "All" ? ["Email"] : []),

  //   ...(selectedBatch !== "All" ? ["Roll NO"] : []),

  //   "Batch",
  //   "Status",
  //   // 👇 Add conditionally
  //   ...(selectedBatch !== "All" ? ["Action"] : []),
  // ];

  const headers = [
    { label: "Registration No", value: "registration_no" },
    { label: "Student Name", value: "full_name" },
    { label: "Father Name", value: "father_name" },
    ...(selectedBatch === "All" ? [{ label: "Email", value: "email" }] : []),
    ...(selectedBatch !== "All"
      ? [{ label: "Roll No", value: "roll_no" }]
      : []),
    { label: "Batch", value: "batch_name" },
    { label: "Status", value: "status" },
    ...(selectedBatch !== "All" ? [{ label: "Action", value: "action" }] : []),
  ];

  const handleReset = () => {
    setSearchTerm("");
    setSearchType("full_name"); // optional reset
    setSelectedBatch("All"); // optional reset for batch filter
    fetchStudents(); // 👈 re-fetch data after reset
    setBatchFilter("All");
  };

  const handleDelete = async (param) => {
    // console.log("handleDelete", param.student_batch_ids);

    // Agar multiple IDs comma se separated hain, array bana lo
    const ids = param.student_batch_ids.split(",").map((id) => id.trim());

    // Sweet Alert Confirmation
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will remove the student from the selected batch!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return; // agar user ne cancel kiya

    try {
      // setLoading(true);

      const payload = { id: ids[0] }; // single delete (agar sirf ek id)
      // const payload = { ids }; // agar bulk delete karna ho future me

      const response = await configServ.deleteStudentBatch(payload);

      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: response.message || "Student batch deleted successfully.",
          timer: 2000,
          showConfirmButton: false,
        });

        // ✅ Refresh data after delete
        fetchStudents();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.message || "Failed to delete student batch.",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while deleting.",
      });
    } finally {
      // setLoading(false);
    }
  };

  const handleMove = async (row) => {
    // console.log("handleMove=", row);

    try {
      // 🧩 Step 1: Confirm user wants to move
      const confirmResult = await Swal.fire({
        title: "Move Student?",
        text: `Do you really want to move ${row.full_name}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Move",
        cancelButtonText: "Cancel",
      });

      if (!confirmResult.isConfirmed) return;

      // 🧩 Step 2: Ask for new batch + remarks
      const { value: formValues } = await Swal.fire({
        title: "Move Student to Another Batch",
        html: `
    <div style="
      display: flex; 
      flex-direction: column; 
      align-items: stretch; 
      gap: 10px; 
      width: 100%; 
      max-width: 400px; 
      margin: 0 auto;
    ">
      <select 
        id="newBatch" 
        class="swal2-select" 
        style="
          width: 100%;
          padding: 8px;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 14px;
        ">
        <option value="">-- Select Batch --</option>
        ${batches
          .map(
            (batch) => `<option value="${batch.id}">${batch.item_name}</option>`
          )
          .join("")}
      </select>

      <textarea 
        id="remarks" 
        class="swal2-textarea" 
        placeholder="Enter remarks (optional)"
        style="
          width: 100%;
          height: 90px;
          resize: vertical;
          font-size: 14px;
          border-radius: 6px;
          border: 1px solid #ccc;
          padding: 8px;
        ">
      </textarea>
    </div>
  `,
        focusConfirm: false,
        preConfirm: () => {
          const newBatchId = document.getElementById("newBatch").value;
          const remarks = document.getElementById("remarks").value;
          if (!newBatchId) {
            Swal.showValidationMessage("Please select a new batch!");
            return false;
          }
          return { newBatchId, remarks };
        },
      });

      if (!formValues) return;

      const payload = {
        old_batch_id: parseInt(row.batch_ids, 10),
        new_batch_id: parseInt(formValues.newBatchId, 10),
        company_id: company_id, // 👈 use your actual variable
        student_id: row.id,
        remarks: formValues.remarks,
      };

      // console.log("payload=", payload);

      const response = await configServ.moveSingleStudentToAnotherBatch(
        payload
      );

      if (response.status) {
        Swal.fire(
          "✅ Success",
          response.message || "Student moved successfully!",
          "success"
        );
        // fetchTable(); // 🔁 refresh table after success
        fetchStudents();
      } else {
        Swal.fire(
          "⚠️ Error",
          response.message || "Something went wrong!",
          "error"
        );
      }
    } catch (err) {
      console.log("err", err);

      Swal.fire("❌ Error", err.response.data.message, "error");
    }
  };

  const handleDownloadPDF = (data) => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Already in Target Batch", 14, 20);

    doc.setFontSize(12);
    data.forEach((item, i) => {
      doc.text(`${i + 1}. ${item.full_name}`, 14, 30 + i * 8);
    });

    doc.save("already_in_batch.pdf");
  };

  return (
    <>
      {/* ✅ Update Batch Dialog */}
      <UpdateBatchDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onSave={handleSaveBatch}
        batches={batches}
        selectedBatchs={selectedBatch}
      />

      <CardHeadMenu title={"Batch Enrollment"} isCreate={false} />

      {/* Filters Section */}
      <Box
        sx={{
          mt: 2,
          mb: 3,
          p: 2,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          width: "100%",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* Batch Total & Update Button */}
          <Grid
            item
            xs={12}
            sm={3}
            md={2.5}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              Total: <span style={{ color: "#1976d2" }}>{total}</span>
            </Typography>
            {selectedRows.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  fontWeight: 500,
                  px: 2,
                  py: 0.5,
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
                onClick={canUpdate ? handleUpdate : undefined}
                disabled={!canUpdate}
              >
                Update ({selectedRows.length})
              </Button>
            )}
          </Grid>

          {/* Batch Filter */}
          <Grid item xs={12} sm={3} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Filter</InputLabel>
              <Select
                value={batchFilter}
                onChange={handleFilterChange}
                label="Filter"
              >
                <MenuItem value="All">All Students</MenuItem>
                <MenuItem value="Unassigned">Unassigned to Batch</MenuItem>
                <MenuItem value="Assigned">Assigned to Batch</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Select Batch */}
          <Grid item xs={12} sm={3} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Select Batch</InputLabel>
              <Select
                value={selectedBatch}
                onChange={handleBatchChange}
                label="Select Batch"
              >
                <MenuItem value="All">All Batches</MenuItem>
                {batches.map((batch) => (
                  <MenuItem key={batch.id} value={batch.id}>
                    {batch.item_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Search Type */}
          <Grid item xs={12} sm={3} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Search By</InputLabel>
              <Select
                value={searchType}
                onChange={handleSearchTypeChange}
                label="Search By"
              >
                <MenuItem value="full_name">Name</MenuItem>
                <MenuItem value="father_name">Father Name</MenuItem>
                <MenuItem value="email">Email</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Search Input */}
          <Grid item xs={9} sm={3} md={2}>
            <TextField
              size="small"
              fullWidth
              label={`Search by ${
                searchType === "father_name"
                  ? "Father Name"
                  : searchType === "email"
                  ? "Email"
                  : "Name"
              }`}
              variant="outlined"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </Grid>

          <Grid item xs={2} sm={1} md={1}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              startIcon={<RestartAltIcon />} // 👈 add icon
              onClick={handleReset}
              fullWidth
            >
              {/* Reset */}
            </Button>
          </Grid>
          <MobileView>
            <Grid
              container
              spacing={2}
              sx={{ marginLeft: "1px", marginTop: "2px", marginRight: "1px" }}
            >
              {/* 🔹 Sort Field */}
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Sort Field</InputLabel>
                  <Select
                    value={sortField || ""}
                    onChange={(e) => setSortField(e.target.value)}
                    label="Sort Field"
                  >
                    <MenuItem value="">-- Select Field --</MenuItem>
                    <MenuItem value="full_name">Name</MenuItem>
                    <MenuItem value="father_name">Father Name</MenuItem>
                    <MenuItem value="email">Email</MenuItem>
                    <MenuItem value="roll_no">Roll No</MenuItem>
                    <MenuItem value="registration_no">Registration No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* 🔹 Sort Order */}
              <Grid item xs={12} sm={4} md={2}>
                <FormControl fullWidth size="small">
                  <InputLabel>Order</InputLabel>
                  <Select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                    label="Order"
                  >
                    <MenuItem value="asc">Ascending</MenuItem>
                    <MenuItem value="desc">Descending</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </MobileView>
        </Grid>
      </Box>

      {/* Table Section */}
      <DesktopView>
        <TableContainer component={Paper} sx={{ px: 1 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={headerCellStyle}>
                  <Checkbox
                    checked={
                      selectedRows.length === students.length &&
                      students.length > 0
                    }
                    onChange={handleSelectAll}
                    sx={{ color: "white" }}
                  />
                </TableCell>
                <TableCell style={headerCellStyle}>Sr. No.</TableCell>
                {headers.map((header, index) => {
                  const isActive = sortField === header.value;
                  return (
                    <TableCell
                      key={index}
                      style={headerCellStyle}
                      onClick={() => handleSort(header.value)}
                      sx={{
                        cursor: !["batch_name", "status", "action"].includes(
                          header.value
                        )
                          ? "pointer"
                          : "default",
                      }}
                    >
                      {header.label}
                      {!["batch_name", "status", "action"].includes(
                        header.value
                      ) && (
                        <span style={{ marginLeft: 4 }}>
                          {isActive ? (sortOrder === "asc" ? "▲" : "▼") : "⇅"}
                        </span>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={headers.length + 2} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : students.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={headers.length + 2}
                    align="center"
                    sx={{ color: "red" }}
                  >
                    <b>No Data Found</b>
                  </TableCell>
                </TableRow>
              ) : (
                students.map((row, rowIndex) => (
                  <TableRow key={row.id} sx={rowStyle}>
                    <TableCell sx={cellStyle}>
                      <Checkbox
                        checked={selectedRows.some(
                          (item) => item.id === row.id
                        )}
                        onChange={() => handleRowCheckboxChange(row)}
                      />
                    </TableCell>
                    <TableCell sx={cellStyle}>
                      {page * rowsPerPage + rowIndex + 1}
                    </TableCell>
                    <TableCell sx={cellStyle}>
                      {row.registration_no || "—"}
                    </TableCell>
                    <TableCell sx={cellStyle}>{row.full_name || "—"}</TableCell>
                    <TableCell sx={cellStyle}>
                      {row.father_name || "—"}
                    </TableCell>

                    {selectedBatch === "All" && (
                      <TableCell sx={cellStyle}>{row.email || "—"}</TableCell>
                    )}
                    {selectedBatch !== "All" && (
                      <TableCell>
                        <TextField
                          size="small"
                          type="number"
                          value={
                            row.student_roll !== undefined &&
                            row.student_roll !== null // ONLY check for undefined/null
                              ? row.student_roll // Use the user-edited value, even if it's ""
                              : row.roll_no ?? "" // Fallback to original roll_no or empty string
                          }
                          onChange={(e) => {
                            let value = e.target.value; // ✅ allow full clear or any digits

                            // ✅ Update main students list
                            const newData = [...students];
                            newData[rowIndex].student_roll = value;
                            setStudents(newData);

                            // ✅ Update or auto-select this row when typing
                            setSelectedRows((prev) => {
                              const alreadySelected = prev.some(
                                (item) => item.student_id === row.id
                              );

                              if (alreadySelected) {
                                // Update existing row roll number
                                return prev.map((item) =>
                                  item.student_id === row.id
                                    ? { ...item, student_roll: value }
                                    : item
                                );
                              } else {
                                // Auto-select if user types in unselected row
                                return [
                                  ...prev,
                                  {
                                    id: row.id,
                                    student_id: row.id,
                                    student_roll: value,
                                  },
                                ];
                              }
                            });
                          }}
                          inputProps={{
                            style: { textAlign: "center", minWidth: "60px" },
                          }}
                          sx={{
                            width: "100%",
                            "@media (max-width:600px)": {
                              fontSize: "0.8rem",
                              "& input": { padding: "6px 4px" },
                              minWidth: "50px",
                            },
                          }}
                        />
                      </TableCell>
                    )}

                    <TableCell sx={cellStyle}>
                      {row.batch_titles || (
                        <Typography color="text.secondary">—</Typography>
                      )}
                    </TableCell>
                    <TableCell sx={cellStyle}>
                      <Chip
                        label={row.batch_titles ? "Assigned" : "Unassigned"}
                        color={row.batch_titles ? "success" : "warning"}
                        size="small"
                      />
                    </TableCell>
                    {selectedBatch !== "All" && (
                      <TableCell
                        sx={{
                          ...cellStyle,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {/* 🗑️ Delete Button */}
                        <IconButton
                          color="error"
                          size="small"
                          onClick={
                            canDelete ? () => handleDelete(row) : undefined
                          }
                          disabled={!canDelete}
                        >
                          <GridDeleteIcon fontSize="small" />
                        </IconButton>

                        {/* 🔀 Move Button */}
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={canMove ? () => handleMove(row) : undefined}
                          disabled={!canMove}
                          title="Move Student"
                        >
                          <SwapHorizIcon fontSize="small" />{" "}
                          {/* 🔁 Move Icon */}
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </DesktopView>

      <MobileView>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          <FormControlLabel
            label="Select All"
            control={
              <Checkbox
                checked={
                  selectedRows.length === students.length && students.length > 0
                }
                onChange={handleSelectAll}
                sx={{
                  color: pink[800],
                  "&.Mui-checked": {
                    color: pink[600],
                  },
                }}
              />
            }
          />
        </div>
        {/* 📱 Card View for Mobile */}
        <Grid container spacing={2}>
          {loading ? (
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={4}
              >
                <CircularProgress />
              </Box>
            </Grid>
          ) : students.length === 0 ? (
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={4}
              >
                <Typography color="error" fontWeight={600}>
                  No Data Found
                </Typography>
              </Box>
            </Grid>
          ) : (
            students.map((row, rowIndex) => (
              <Grid item xs={12} key={row.id}>
                <Card
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: "#f9fafb",
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Checkbox
                      checked={selectedRows.some((item) => item.id === row.id)}
                      onChange={() => handleRowCheckboxChange(row)}
                    />
                    <Chip
                      label={row.batch_titles ? "Assigned" : "Unassigned"}
                      color={row.batch_titles ? "success" : "warning"}
                      size="small"
                    />
                  </Box>

                  <Box mt={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {row.full_name || "—"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Reg No: {row.registration_no || "—"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Father: {row.father_name || "—"}
                    </Typography>
                    {selectedBatch === "All" && (
                      <Typography variant="body2" color="text.secondary">
                        Email: {row.email || "—"}
                      </Typography>
                    )}
                    <Typography variant="body2" color="text.secondary">
                      Batch: {row.batch_titles || "—"}
                    </Typography>

                    {selectedBatch !== "All" && (
                      <Box mt={1} display="flex" justifyContent="start">
                        <TextField
                          size="small"
                          type="number"
                          label="Roll No"
                          value={
                            row.student_roll !== undefined &&
                            row.student_roll !== null // ONLY check for undefined/null
                              ? row.student_roll // Use the user-edited value, even if it's ""
                              : row.roll_no ?? "" // Fallback to original roll_no or empty string
                          }
                          onChange={(e) => {
                            let value = e.target.value;

                            // 🧹 Allow empty or numeric only
                            if (value === "") {
                              value = ""; // allow full delete
                            } else {
                              // Remove non-digits and convert to Number
                              value = Number(value.replace(/\D/g, ""));
                            }

                            // ✅ Update students state
                            const newData = [...students];
                            newData[rowIndex].student_roll = value;
                            setStudents(newData);

                            // ✅ Update selectedRows state (auto-select on change)
                            setSelectedRows((prev) => {
                              const alreadySelected = prev.some(
                                (item) => item.student_id === row.id
                              );

                              if (alreadySelected) {
                                // Update existing selected row roll number
                                return prev.map((item) =>
                                  item.student_id === row.id
                                    ? { ...item, student_roll: value }
                                    : item
                                );
                              } else {
                                // Auto-select this row when user types new roll no
                                return [
                                  ...prev,
                                  {
                                    id: row.id,
                                    student_id: row.id,
                                    student_roll: value,
                                  },
                                ];
                              }
                            });
                          }}
                          sx={{
                            width: "120px",
                            "& .MuiInputBase-input": {
                              fontSize: "0.8rem",
                              textAlign: "center",
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "0.75rem",
                            },
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                        />
                      </Box>
                    )}
                  </Box>

                  {selectedBatch !== "All" && (
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                      gap={1}
                      mt={1}
                    >
                      <IconButton
                        color="error"
                        size="small"
                        onClick={
                          canDelete ? () => handleDelete(row) : undefined
                        }
                        disabled={!canDelete}
                      >
                        <GridDeleteIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        color="primary"
                        size="small"
                        onClick={canMove ? () => handleMove(row) : undefined}
                        disabled={!canMove}
                        title="Move Student"
                      >
                        <SwapHorizIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Card>
              </Grid>
            ))
          )}
        </Grid>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </MobileView>

      {/* dialog for download PDF */}
      <Dialog
        open={showAlreadyDialog}
        onClose={() => setShowAlreadyDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Already in Target Batch</DialogTitle>
        <DialogContent dividers>
          {alreadyInList.length > 0 ? (
            <ul>
              {alreadyInList.map((s) => (
                <li key={s.student_id}>{s.full_name}</li>
              ))}
            </ul>
          ) : (
            <p>No students found.</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDownloadPDF(alreadyInList)}
            variant="contained"
            color="primary"
          >
            Download PDF
          </Button>
          <Button onClick={() => setShowAlreadyDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BatchEnrollment;
